import { DatePipe, DecimalPipe } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthState } from '@app/core/auth/states/auth.state';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateCompiler, TranslateModule } from '@ngx-translate/core';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsModule } from '@ngxs/store';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { environment } from './../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppsListComponent } from './core/components/apps-list/apps-list.component';
import { HeaderComponent } from './core/components/header/header.component';
import { CoreModule } from './core/core.module';
import { DirectivesModule } from './core/directives/directives.module';
import { AppState } from './core/states/app.state';
import { EventsTrackingState } from './core/states/event-tracking.state';
import { OnboardingState } from './core/states/onboarding.state';
import { ResponsiveState } from './core/states/responsive.state';
import { StepperState } from './core/states/stepper.state';
import { AdminModule } from './features/admin/admin.module';
import { AppConfigurationModule } from './features/app-content/app-configuration.module';
import { MonetizationState } from './features/app-content/states/monetizations.state';
import { PrivacyState } from './features/app-content/states/privacy.state';
import { PublishingState } from './features/app-publishing/states/publishing.state';
import { AssetsState } from './features/app-settings/states/assets.state';
import { LoginComponent } from './features/login/login.component';
import { NotificationsModule } from './features/notifications/notifications.module';
import { StatisticsModule } from './features/statistics/statistics.module';
import { MaterialModule } from './material.module';
import { AlertService } from './ui/components/alert/alert.service';
import { UIState } from './ui/states/ui.state';
import { UiModule } from './ui/ui.module';

@NgModule({
  declarations: [AppComponent, LoginComponent, HeaderComponent, AppsListComponent],
  bootstrap: [AppComponent],
  imports: [
    NgxsModule.forRoot(
      [
        AuthState,
        AppState,
        EventsTrackingState,
        ResponsiveState,
        MonetizationState,
        PrivacyState,
        OnboardingState,
        UIState,
        StepperState,
        AssetsState,
        PublishingState,
      ],
      {
        developmentMode: !environment.production,
      },
    ),
    NgxsRouterPluginModule.forRoot(),
    AdminModule,
    BrowserModule,
    AppConfigurationModule,
    MaterialModule,
    AppRoutingModule,
    NotificationsModule,
    StatisticsModule,
    GoogleMapsModule,
    UiModule,
    CoreModule,
    FontAwesomeModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    BaseChartDirective,
    DirectivesModule,
    TranslateModule.forRoot({
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    }),

    ReactiveFormsModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    AlertService,
    DatePipe,
    DecimalPipe,
    [provideCharts(withDefaultRegisterables())],
    { provide: 'googleTagManagerId', useValue: environment.gtm },
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
  ],
})
export class AppModule {}
